import { motion } from "framer-motion";
import { Link } from "react-router-dom";
export default function PersonalInjury() {
  return (

     <motion.div
      className="max-w-4xl mx-auto px-6 py-12 text-center"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <h1 className="text-3xl md:text-4xl font-bold mb-6">Personal Injury</h1>
      <p className="text-lg text-gray-700 leading-relaxed mb-8 text-left">
        Have you suffered injuries out of an accident or a slip and fall? You may be entitled to compensation for injuries, lost of income and more. Personal injury laws in Alberta can be complex to navigate alone without legal advice. You may be entitled to more compensation than what the insurance companies might be offering you as settlement.
We can advise you injury claim assessments, suggest legal options and represent you in negotiations or court proceedings, if necessary.
Get in touch with us before you settle your claim.

      </p>
      <Link
        to="/contact"
        className="inline-block px-6 py-3 rounded-lg bg-blue-900 text-white font-semibold shadow hover:bg-blue-800 transition"
      >
        Request Consultation
      </Link>

    </motion.div>
  );
}
